// export default {
//     install(Vue) {
//         Vue.prototype.relaValidProp = function (num,CombinedDataMap,parentRules, row, col, propid, propvalue, algcontent, slave2masterMap, propItemMap, ifSelect, selectValue, optionMap, primaryData,otherParameter) {
//             // debugger
//             // otherParameter 其他参数map类型，以后的参数放进这里，就不要添加额外的参数了
//             //
//             if (otherParameter === undefined || otherParameter == '' || otherParameter == null) {
//                 otherParameter = {viewtype:"",idx:""}
//             }
//             var that = this;
//             var propname = col.name;
//             //增加算法校验 add by lxs at 20200310
//             if (!(algcontent == '' || algcontent == 'undefined' || algcontent == null || algcontent == "null")) {
//                 var paramObj = {
//                     algcontent: algcontent,
//                     propval: propvalue
//                 };
//                 that.$ajax
//                     .post('/infoAlg/executeScript', paramObj)
//                     .then((res) => {
//                         if (res.data.code == 200) {
//                             if (res.data.obj) {
//                             }
//                         } else {
//                             that.$notify.error(propname + ":algorithm valid fail!")
//                             return false;
//                         }
//                     });
//             }
//
//             /**——————————————————————————————————标准词校验 开始*/
//             var vpIds = propid.split("|");
//             var wObj = {
//                 "viewid": vpIds[0],
//                 "propid": vpIds[1],
//                 "propvalue": propvalue
//             };
//             debugger
//             that.$ajax
//                 .post('/infoTaskbill/standwordValid', wObj)
//                 .then((res) => {
//                     if (res.data.code == 200) {
//                         var standWordval = res.data.msg;
//                         this.$confirm('您输入的【' + propvalue + '】不是标准词，是否替换为标准词【' + standWordval + '】?', '提示', {
//                             confirmButtonText: '确定',
//                             cancelButtonText: '取消',
//                             type: 'warning'
//                         }).then(() => {
//                             row[col.vbyname][col.byname] = standWordval;
//                         }).catch(() => {
//
//                         });
//                     }
//                 });
//
//
//             /**——————————————————————————————————标准词校验 结束*/
//
//
//             /**——————————————————————————————————自动代入值 开始*/
//             debugger
//             //显示规则:0-名 1-值 2-名/值
//             // if (propItemMap.keys("master_" + propid).length !== undefined) {
//             // debugger
//             var item = propItemMap.get("master_" + propid);
//             if (!item) {
//                 return true;
//             }
//             for (var i in item) {
//                 debugger
//                 if (item[i].relationValid.rule_code == "002") {//002代表自动代入
//                     if (null == item[i].calculateSymbol && null == item[i].slavecalculateSymbol){
//                         /**
//                          * //当A选择人员后，B自动带出A选人员所在部门
//                          * 注意：
//                          * 1.配置的方式是将从属性的取值配置为 视图别名和属性别名，例如 ： caigouguizeshitu_chengben
//                          * 2.主属性和从属性的质检符号都配置为空
//                          */
//                         debugger
//                         if (optionMap != "" && optionMap != null && optionMap != undefined){
//                             if(optionMap.has('datajson')){
//                                 var datajson = optionMap.get('datajson');
//                                 var slaveprop_value = item[i].slaveprop_value;
//                                 if (slaveprop_value != null && slaveprop_value != "") {
//                                     var valiasname = slaveprop_value.split("_")[0];
//                                     var paliasname = slaveprop_value.split("_")[1];
//                                     row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
//                                     if (ifSelect) {//如果是下拉框和弹出框
//                                         row[item[i].salveView.byname][item[i].salveProp.byname+ '|X'] = datajson[valiasname][paliasname+ '|X'];
//                                     }
//                                 }
//                             }else{
//                                 if(primaryData != null){
//                                     that.$ajax
//                                         .post('/infoTaskbill/queryJsonByPrimaryData', primaryData)
//                                         .then((res) => {
//                                             if (res.data.code == 200) {
//                                                 var datajson = res.data.obj;
//                                                 var slaveprop_value = item[i].slaveprop_value;
//                                                 if (slaveprop_value != null && slaveprop_value != "") {
//                                                     var valiasname = slaveprop_value.split("_")[0];
//                                                     var paliasname = slaveprop_value.split("_")[1];
//                                                     row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
//                                                     if (ifSelect) {//如果是下拉框和弹出框
//                                                         var according = item[i].salveProp.according;
//                                                         if (according == 0) {
//                                                             row[item[i].salveView.byname][item[i].salveProp.byname+ '|X'] = datajson[valiasname][paliasname];
//                                                         } else if (according == 1) {
//                                                             row[item[i].salveView.byname][item[i].salveProp.byname+ '|X'] = datajson[valiasname][paliasname];
//                                                         } else {
//                                                             row[item[i].salveView.byname][item[i].salveProp.byname+ '|X'] = datajson[valiasname][paliasname+ '|X'];
//                                                         }
//
//                                                     }
//                                                 }
//                                             }
//                                         });
//                                 }
//                             }
//                         }
//                     } else {
//                         let symbol = item[i].calculateSymbol;
//                         // 判断视图类型
//                         // 多值视图
//                         // debugger
//
//                         if (otherParameter.viewtype === "3") {
//                             var mstval = row[item[i].masterView.byname][otherParameter.idx][item[i].masterProp.byname];
//                             var confmval = item[i].masterprop_value;
//                             var confsval = item[i].slaveprop_value;
//                             if (mstval != '' && confmval != '' && confmval != null) {
//                                 if (checkout(mstval,confmval,symbol)) {
//                                     if (confsval != '') {
//                                         if (confsval.indexOf('~') && item[i].salveProp.style == 5) {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = confsval.split('~')[0];
//                                             var according = item[i].salveProp.according;
//                                             if (according == 0) {
//                                                 row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
//                                             } else if (according == 1) {
//                                                 row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
//                                             } else {
//                                                 row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
//                                             }
//                                         } else {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = confsval;
//                                         }
//                                     }
//                                 }
//                             } else {
//                                 // debugger
//                                 if (ifSelect) {//如果是下拉框和弹出框
//                                     var according = item[i].salveProp.according;
//                                     var salveStyle = item[i].salveProp.style;
//                                     if (according == 0) {
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
//                                         } else {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = optionMap.get(selectValue);
//                                         }
//                                     } else if (according == 1) {
//                                         row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = selectValue;
//                                         }
//                                     } else {
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
//                                         } else {
//                                             row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
//                                         }
//                                     }
//
//                                 } else {
//                                     row[item[i].salveView.byname][item[i].salveProp.byname] = mstval;
//                                 }
//                             }
//                         }else if (otherParameter.viewtype === "4") {  // 多维视图数据带入
//                             debugger
//                             var mstval;
//                             if (otherParameter.inputType === 'text'){
//                                 mstval = row[item[i].masterProp.byname];
//                             } else {
//                                 mstval = row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].masterProp.byname];
//                             }
//                             var confmval = item[i].masterprop_value;
//                             var confsval = item[i].slaveprop_value;
//                             if (mstval != '' && confmval != '' && confmval != null) {
//                                 if (checkout(mstval,confmval,symbol)) {
//                                     if (confsval != '') {
//                                         if (confsval.indexOf('~') && item[i].salveProp.style == 5) {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = confsval.split('~')[0];
//                                             var according = item[i].salveProp.according;
//                                             if (according == 0) {
//                                                 row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
//                                             } else if (according == 1) {
//                                                 row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
//                                             } else {
//                                                 row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
//                                             }
//                                         } else {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = confsval;
//                                         }
//                                     }
//                                 }
//                             } else {
//                                 // debugger
//                                 if (ifSelect) {//如果是下拉框和弹出框
//                                     var according = item[i].salveProp.according;
//                                     var salveStyle = item[i].salveProp.style;
//                                     if (according == 0) {
//
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
//                                             row[otherParameter.parViewByname][otherParameter.org + "_" + item[i].masterView.name][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
//                                         } else {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = optionMap.get(selectValue);
//                                         }
//                                     } else if (according == 1) {
//                                         row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = selectValue;
//                                         }
//                                     } else {
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
//                                             row[otherParameter.parViewByname][otherParameter.org + "_" + item[i].masterView.name][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
//                                         } else {
//                                             row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue + '/' + optionMap.get(selectValue);
//                                         }
//                                     }
//
//                                 } else {
//                                     row[item[i].salveProp.byname] = mstval;
//                                 }
//                             }
//                         } else {  // 其他类型视图 规则视图、业务视图
//                             var mstval = row[item[i].masterView.byname][item[i].masterProp.byname];
//                             var confmval = item[i].masterprop_value;
//                             var confsval = item[i].slaveprop_value;
//                             if (mstval != '' && confmval != '' && confmval != null) {
//                                 if (checkout(mstval,confmval,symbol)) {
//                                     if (confsval != '') {
//                                         if (confsval.indexOf('~') && item[i].salveProp.style == 5) {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = confsval.split('~')[0];
//                                             var according = item[i].salveProp.according;
//                                             if (according == 0) {
//                                                 row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
//                                             } else if (according == 1) {
//                                                 row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
//                                             } else {
//                                                 row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
//                                             }
//                                         } else {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = confsval;
//                                         }
//                                     }
//                                 }
//                             } else {
//                                 // debugger
//                                 if (ifSelect) {//如果是下拉框和弹出框
//                                     var according = item[i].salveProp.according;
//                                     var salveStyle = item[i].salveProp.style;
//                                     if (according == 0) {
//
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
//                                             row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
//                                         } else {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = optionMap.get(selectValue);
//                                         }
//                                     } else if (according == 1) {
//                                         row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = selectValue;
//                                         }
//                                     } else {
//                                         if (salveStyle == '5' || salveStyle == '8') {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
//                                             row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
//                                         } else {
//                                             row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue + '/' + optionMap.get(selectValue);
//                                         }
//                                     }
//
//                                 } else {
//                                     row[item[i].salveView.byname][item[i].salveProp.byname] = mstval;
//                                 }
//                             }
//                         }
//
//                     }
//                 }
//                 else if(item[i].relationValid.rule_code == "003"){//自动计算值，目前只支持规则视图和业务视图
//                     debugger
//                     if ("excutescript" != item[i].calculateSymbol.calcu_symbol){
//                         continue;
//                     }
//                     /**
//                      * 这里的主属性的实际的值，作为算法脚本的参数传入，然后执行算法得到结果就是从属性的值
//                      */
//                     debugger
//                     var mstval = row[item[i].masterView.byname][item[i].masterProp.byname];
//                     if(mstval == '' || mstval == null){
//                         row[item[i].salveView.byname][item[i].salveProp.byname] = '';
//                     }
//                     var algid = item[i].masterprop_value;//主属性取值这里是算法脚本的id
//                     //这里需要调用一下后台执行引擎获取结果
//                     debugger
//                     var sViewByname = item[i].salveView.byname;
//                     var sPropByname = item[i].salveProp.byname;
//                     queryValByAlg(mstval,algid,sViewByname,sPropByname,row,that);
//                 }
//             }
//             /**——————————————————————————————————自动代入值 结束*/
//
//             /**——————————————————————————————————组合校验 开始*/
//             //CombinedDataMap 临时存储组合校验的值
//             //num 表示是哪一行的数据
//             debugger
//             var item = propItemMap.get("master_" + propid);
//             var returnState = true
//             for (var k in item) {
//                 if (item[k].relationValid.rule_code == "011") {//011 组合验证
//                     //
//                     /**
//                      * 1.主属性的表达式：填主属性拼接符号
//                      * 2.主属性取值：填主属性的序号
//                      * @type {string|*}
//                      */
//
//                         //主属性取值
//                         // 主属性的表达式
//                         // debugger
//                     var concatStr = '';
//                     if (item[k].calculateSymbol != null && item[k].calculateSymbol != "" && item[k].calculateSymbol != undefined) {
//                         concatStr = item[k].calculateSymbol.calcu_symbol;
//                     }
//                     //组装的值
//                     var slaveV = row[item[k].salveView.byname][item[k].salveProp.byname];
//                     //组装的值的位置
//                     var pix = item[k].masterprop_value;
//                     //默认值
//                     var intPix = 1;
//                     //不为空时重新赋值
//                     if (pix != null) {
//                         intPix = parseInt(pix);
//                     }
//                     // debugger
//                     // if (this.GLOBAL.projectName === 'lvxue'|| this.GLOBAL.projectName === 'poc') {
//                     if (1==1) {
//                         if (concatStr == null || concatStr == "") {
//                             //金风poc 使用|
//                             concatStr = "|";
//                         }
//                         //获取组装条件
//                         var salveValue = item[k].slaveprop_value;
//                         //判断组装条件是否存在
//                         if (salveValue != null && salveValue != '' && salveValue.indexOf('_')) {
//                             //分割组装条件，格式为视图别名_属性别名_校验值
//                             var salveArray = salveValue.split('_');
//                             //说明有需要某个字段来判断的组合验证
//                             var propView = salveArray[0];
//                             var propid = salveArray[1];
//                             //获取这个组装条件的值
//                             var chakValue = row[propView][propid];
//                             //如果选择的属性与组合方式判断的条件一致的情况下
//                             if (propid == item[k].masterProp.byname) {
//                                 //第一次选择了判断条件后面又修改的情况下，重新拼接所有的值
//                                 if (otherParameter.oldVal != null && otherParameter.oldVal != '' && otherParameter.oldVal != selectValue && selectValue != null && selectValue != '') {
//                                     returnState = "changeValue"
//                                     //先删除组装数据中的数据
//                                     // debugger
//                                     var svArrNew = [];
//                                     if (slaveV != "" && slaveV != null) {
//                                         for (var i = 0; i < intPix - 1; i++) {
//                                             svArrNew[i] = slaveV.split(concatStr)[i];
//
//                                         }
//                                         slaveV = svArrNew.join(concatStr);
//                                         row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
//                                     }
//                                     //获取需组装的值的所有属性
//                                     var slaveProp = item[k].salveView.id + "|" + item[k].salveProp.id;
//                                     var zuzhuang = propItemMap.get("slave_" + slaveProp);
//                                     var svArrNew = [];
//                                     for (var kk in zuzhuang) {
//                                         if (zuzhuang[kk].relationValid.rule_code == "011") {
//                                             //先获取组装条件
//                                             var newSalveValue = zuzhuang[kk].slaveprop_value;
//                                             //分割组装条件，格式为视图别名_属性别名_校验值
//                                             var newSalveArray = newSalveValue.split('_');
//                                             // if(newSalveArray[2].split(',').indexOf(selectValue) == -1){
//                                             //     //如果校验不通过则不进行组装
//                                             //     continue
//                                             // }
//                                             //默认值
//                                             var newIntPix = 1;
//                                             //获取组装的位置
//                                             var newPix = zuzhuang[kk].masterprop_value;
//                                             if (newPix != null) {
//                                                 newIntPix = parseInt(newPix);
//                                             }
//                                             if (newIntPix > intPix) {
//                                                 row[zuzhuang[kk].masterView.byname][zuzhuang[kk].masterProp.byname] = '';
//                                                 if (zuzhuang[kk].masterProp.style == 5) {
//                                                     row[zuzhuang[kk].masterView.byname][zuzhuang[kk].masterProp.byname + '|X'] = '';
//                                                 }
//                                             }
//                                         }
//                                     }
//                                 }
//                                 //如果是选择的属性也在组装中重新获取值
//                                 if (ifSelect) {
//                                     chakValue = selectValue;
//                                 }
//                             }
//                             if (chakValue != null && chakValue != '') {
//                                 //获取判断的值
//                                 var jiaoyanvalue = salveArray[2].split(',');
//                                 if (jiaoyanvalue.indexOf(chakValue) == -1) {
//                                     if (row.billname == '半成品') {
//                                         if (chakValue != 1) {
//                                             if (col.name != '附加信息') {
//                                                 slaveV = "";
//                                                 console.log(row[item[k].salveView.byname]);
//                                                 row[item[k].salveView.byname].fujiaxinxi9='';
//                                                 row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
//                                             }
//                                         }
//                                     }
//                                     //如果校验不通过则不进行组装
//                                     continue
//                                 } else {
//                                     if ((row.billname === '半成品' && col.name === '中类') && otherParameter.oldVal != propvalue) {
//                                         /*slaveV = "";
//                                         row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
//                                         continue*/
//                                         row[item[k].salveView.byname].fujiaxinxi9='';
//                                         // debugger
//                                         var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
//                                         if (ifSelect) {
//                                             mstval = optionMap.get(selectValue);
//                                         }
//                                         var svArr = [];
//                                         svArr[intPix - 1] = mstval;
//                                         if (intPix != 1) {
//                                             for (var i = 0; i < intPix - 1; i++) {
//                                                 svArr[i] = '';
//                                             }
//                                         }
//                                         slaveV = svArr.join(concatStr);
//                                         row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
//                                         continue;
//                                     }
//                                 }
//                             } else {
//                                 //当前的组合属性不是第一级，并且不是选择条件的属性时判断
//                                 if (pix != '1' && propid != item[k].masterProp.byname) {
//                                     // debugger
//                                     var propname = '';
//                                     if (that.metaDatas) {
//                                         that.metaDatas.forEach((item1) => {
//                                             // debugger
//                                             if (item1.vbyname == propView) {
//                                                 if (item1.jhBillPropertiesList) {
//                                                     item1.jhBillPropertiesList.forEach((prop) => {
//                                                         // debugger
//                                                         if (prop.byname == propid) {
//                                                             propname = prop.name;
//                                                         }
//                                                     });
//                                                 }
//                                             }
//                                         });
//                                     }
//                                     return "请先选择组合方式的判断条件:" + propname;
//                                 }
//                             }
//                         }
//                         // debugger
//                         //获取需要组装的值
//                         var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
//                         //雅化特殊处理
//                         /*if (ifSelect) {
//                             mstval = optionMap.get(selectValue);
//                         }*/
//                         //如果组装的值为空说明还未组装，是第一次组装
//                         if (slaveV == "" || slaveV == null) {
//                             var svArr = [];
//                             svArr[intPix - 1] = mstval;
//                             if (intPix != 1) {
//                                 for (var i = 0; i < intPix - 1; i++) {
//                                     svArr[i] = '';
//                                 }
//                             }
//                             slaveV = svArr.join(concatStr);
//                         } else {
//
//                             /*if (slaveV.indexOf("--") < 0) {
//                                 var svArr = [slaveV];
//                                 svArr[intPix-1] = mstval;
//                                 if (intPix != 1) {
//                                     for (var i=0;i<intPix-1;i++) {
//                                         svArr[i] = '';
//                                     }
//                                 }
//                                 slaveV = svArr.join('--');
//                             }else{*/
//                             // debugger
//                             svArr = slaveV.split(concatStr);
//                             svArr[intPix - 1] = mstval;
//                             // }
//                             slaveV = svArr.join(concatStr);
//                         }
//                     } else {
//                         // debugger
//                         //获取需要组装的值
//                         // debugger
//                         var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
//                         if (ifSelect) {
//                             mstval = optionMap.get(selectValue);
//                         }
//                         //临时存储组合属性的key
//                         var key = item[k].salveView.byname + "_" + item[k].salveProp.byname + "_" + num;
//                         var CombinedData = [];
//                         //如果组装的值为空说明还未组装，是第一次组装
//                         if (slaveV == "" || slaveV == null) {
//                             var svArr = [];
//                             CombinedData[intPix - 1] = mstval + "*_*" + concatStr;
//                             CombinedDataMap.set(key, CombinedData);
//                             if (intPix != 1) {
//                                 slaveV = concatStr + mstval;
//                             } else {
//                                 slaveV = mstval;
//                             }
//                         } else {
//                             debugger
//                             if (CombinedDataMap.size > 0 && CombinedDataMap != "" && CombinedDataMap != null && CombinedDataMap != undefined){
//                                 if (CombinedDataMap.has(key)) {
//                                     CombinedData = CombinedDataMap.get(key);
//                                     CombinedData[intPix - 1] = mstval + "*_*" + concatStr;
//                                     var salveVNew = '';
//                                     for (var i = 0; i < CombinedData.length; i++) {
//                                         if (CombinedData[i] != '' && CombinedData[i] != null) {
//                                             salveVNew += CombinedData[i].split("*_*")[1] + CombinedData[i].split("*_*")[0];
//                                         }
//                                     }
//                                     slaveV = salveVNew;
//                                 } else {
//                                     svArr = slaveV.split(concatStr);
//                                     svArr[intPix - 1] = mstval;
//                                     slaveV = svArr.join(concatStr);
//                                 }
//                             }
//                         }
//                     }
//                     //组装值的赋值
//                     row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
//
//                 }
//             }
//             return returnState
//             /**——————————————————————————————————组合校验 结束*/
//
//             /**——————————————————————————————————必填校验 开始*/
//             if (slave2masterMap.size > 0) {
//                 var slaveid = slave2masterMap.get(propid);
//                 var sItem = propItemMap.get("master_" + propid);
//                 if (slaveid == undefined || slaveid == null) {
//                     return true;
//                 }
//                 var masterprop_value = sItem.masterprop_value;
//                 var slaveprop_value = sItem.slaveprop_value;
//                 /**
//                  * 先看一下主属性是否满足条件，如果主属性不满足条件就不校验了
//                  * */
//                 var mval = row[sItem.masterView.byname][sItem.masterProp.byname];
//                 if (ifSelect) {
//                     mval = selectValue;
//                 }
//                 var masterexpress =  sItem.calculateSymbol == null ? null : sItem.calculateSymbol.calcu_symbol;
//                 var masterFlag = that.validSinglePropByRule(sItem.masterprog_id, masterexpress, masterprop_value, mval);
//
//                 //必填做特殊处理
//                 var sval = row[sItem.salveView.byname][sItem.salveProp.byname];
//                 var slaveexpress =  sItem.slavecalculateSymbol == null ? null : sItem.slavecalculateSymbol.calcu_symbol;
//                 var slaveFlag = that.validSinglePropByRule(slaveid, slaveexpress, slaveprop_value, sval);
//                 if (masterFlag != 'true') {
//                     parentRules[sItem.salveProp.byname] = [];
//                     return true;
//                 } else {
//                     if (slaveFlag != 'true') {
//                         parentRules[sItem.salveProp.byname].push({
//                             required: true,
//                             message: '必填字段',
//                             trigger: 'blur'
//                         });
//                         return slaveFlag;
//                     } else {
//                         parentRules[sItem.salveProp.byname] = [];
//                         return true;
//                     }
//                 }
//
//             } else {
//                 return true
//             }
//             /**——————————————————————————————————必填校验 结束*/
//             // }
//         }
//
//         async function queryValByAlg(mstval,algid,sViewByname,sPropByname,row,that){
//             await that.$ajax
//                 .post('/infoAlg/excuteAlgByAlgid', {"mstval": mstval,"algid":algid})
//                 .then(function (response) {
//                     if (response.data.code == 200) {
//                         debugger
//                         row[sViewByname][sPropByname] = response.data.msg;
//                     }
//                 });
//         }
//
//
//         Vue.prototype.validSinglePropByRule = function (propid, express, value, realValue) {
//             // if (typeof (value) == 'undefined' || typeof (realValue) == 'undefined' || value == '' || value == null || realValue == '') {
//             //     debugger
//             //     if("notnull" == express){
//             //         return "未通过必填校验";
//             //     }
//             //     return '值为空,无法关联验证';
//             // }
//             var flag = 'true';
//             try {
//                 switch (express) {
//                     case "notnull":
//                         if (realValue == null || realValue == "" || realValue == 'undefined') {
//                             flag = "为必填项";
//                         }
//                         break;
//                     case "isnull":
//                         if (realValue != null && realValue != "" && realValue != 'undefined') {
//                             flag = "为必空项";
//                         }
//                         break;
//                     case '>':
//                         if (!(parseInt(realValue) > parseInt(value))) {
//                             flag = "必须大于" + value;
//                         }
//                         break;
//                     case '<':
//                         if (!(parseInt(realValue) < parseInt(value))) {
//                             flag = "必须小于" + value;
//                         }
//                         break;
//                     case '=':
//                         if (!(parseInt(realValue) == parseInt(value))) {
//                             flag = "必须等于" + value;
//                         }
//                         break;
//                     case '!=':
//                         if (!(parseInt(realValue) != parseInt(value))) {
//                             flag = "必须不等于" + value;
//                         }
//                         break;
//                     case '>=':
//                         if (!(parseInt(realValue) >= parseInt(value))) {
//                             flag = "必须大于等于" + value;
//                         }
//                         break;
//                     case '<=':
//                         if (!(parseInt(realValue) <= parseInt(value))) {
//                             flag = "必须小于等于" + value;
//                         }
//                         break;
//                     case 'inwithedge'://[3,10]
//                         var tempVal = value.split(",");
//                         var leftValue = tempVal[0].substring(1);
//                         var rightValue = tempVal[1].substring(0, tempVal[1].length - 1);
//                         if (!(parseInt(realValue) >= leftValue && parseInt(realValue) <= rightValue)) {
//                             flag = "必须在" + value + "范围内";
//                         }
//                         break;
//                     case 'inwithoutedge'://(3,10)
//                         var tempVal1 = value.split(",");
//                         var leftValue1 = tempVal1[0].substring(1);
//                         var rightValue1 = tempVal1[1].substring(0, tempVal1[1].length - 1);
//                         if (!(parseInt(realValue) > leftValue1 && parseInt(realValue) < rightValue1)) {
//                             flag = "必须在" + value + "范围内";
//                         }
//                         break;
//                     case 'any'://(1,5,10)
//                         var tempVal2 = value.substring(1, value.length - 1).split(",");
//                         for (var i in tempVal2) {
//                             if (realValue == tempVal2[i]) {
//                                 flag = 'true';
//                                 break;
//                             }
//                         }
//                         flag = "必须在" + value + "中选一个";
//                         break;
//                     case 'is'://字符串匹配
//                         if (!(realValue == value)) {
//                             flag = "必须是" + value;
//                         }
//                         break;
//                     default:
//                         return 'true';
//                 }
//                 return flag;
//             } catch (e) {
//                 return 'true';
//             }
//         }
//     }
// }
//
// function checkout(mstval, conmstval, symbolProp) {
//     const symbol = symbolProp != '' ? symbolProp.calcu_symbol : 'is';
//     let split = conmstval.split(',');
//     const isAllNumberValue = checkNumber(mstval,conmstval,split);
//     switch (symbol) {
//         case 'notnull':
//             return mstval !== undefined && mstval != null && mstval !== '';
//         case 'isnull':
//             return mstval === null || mstval === undefined || mstval === '';
//         case 'lengthgteq':
//             return mstval.length >= conmstval;
//         case 'lengthlteq':
//             return mstval.length <= conmstval;
//         case 'lengtheq':
//             return mstval.length === conmstval;
//         case 'lengthlt':
//             return mstval.length < conmstval;
//         case 'lengthgt':
//             return mstval.length > conmstval;
//         case '<':
//             if (isAllNumberValue){
//                 return mstval < conmstval;
//             }
//         case '=':
//             if (isAllNumberValue){
//                 return mstval === conmstval;
//             }
//         case '>':
//             if (isAllNumberValue){
//                 return mstval > conmstval;
//             }
//         case '!=':
//             if (isAllNumberValue){
//                 return mstval !== conmstval;
//             }
//         case '>=':
//             if (isAllNumberValue){
//                 return mstval >= conmstval;
//             }
//         case '<=':
//             if (isAllNumberValue){
//                 return mstval <= conmstval;
//             }
//         case 'is':
//             return mstval === conmstval;
//         case 'contain':
//             return mstval.includes(conmstval);
//         case 'inwithedge':
//             split = conmstval.split[','];
//             if (isAllNumberValue){
//                 return mstval >= split[0] && mstval <= split[1];
//             }
//         case 'inwithoutedge':
//             split = conmstval.split[','];
//             if (isAllNumberValue){
//                 return mstval > split[0] && mstval < split[1];
//             }
//         case 'iswithoutledge':
//             split = conmstval.split[','];
//             if (isAllNumberValue){
//                 return mstval > split[0] && mstval <= split[1];
//             }
//         case 'iswithoutredge':
//             split = conmstval.split[','];
//             if (isAllNumberValue){
//                 return mstval >= split[0] && mstval < split[1];
//             }
//     }
//     return false;
// }
//
// function checkNumber(mstval,confMstval,scopeArr){
//     return !Number.isNaN(Number(mstval)) && scopeArr.length == 2
//         ? (!Number.isNaN(Number(scopeArr[0])) && !Number.isNaN(Number(scopeArr[1])))
//         : (!Number.isNaN(Number(confMstval)))
// }
//
export default {
    install(Vue) {
        Vue.prototype.relaValidProp = function (num,CombinedDataMap,parentRules, row, col, propid, propvalue, algcontent, slave2masterMap, propItemMap, ifSelect, selectValue, optionMap, primaryData,otherParameter) {
            // debugger
            // otherParameter 其他参数map类型，以后的参数放进这里，就不要添加额外的参数了
            //
            if (otherParameter === undefined || otherParameter == '' || otherParameter == null) {
                otherParameter = {viewtype:"",idx:""}
            }
            var that = this;
            var propname = col.name;
            //增加算法校验 add by lxs at 20200310
            if (!(algcontent == '' || algcontent == 'undefined' || algcontent == null || algcontent == "null")) {
                var paramObj = {
                    algcontent: algcontent,
                    propval: propvalue
                };
                that.$ajax
                    .post('/infoAlg/executeScript', paramObj)
                    .then((res) => {
                        if (res.data.code == 200) {
                            if (res.data.obj) {
                            }
                        } else {
                            that.$notify.error(propname + ":algorithm valid fail!")
                            return false;
                        }
                    });
            }

            /**——————————————————————————————————标准词校验 开始*/
            var vpIds = propid.split("|");
            var wObj = {
                "viewid": vpIds[0],
                "propid": vpIds[1],
                "propvalue": propvalue
            };
            debugger
            that.$ajax
                .post('/infoTaskbill/standwordValid', wObj)
                .then((res) => {
                    if (res.data.code == 200) {
                        var standWordval = res.data.msg;
                        this.$confirm('您输入的【' + propvalue + '】不是标准词，是否替换为标准词【' + standWordval + '】?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            row[col.vbyname][col.byname] = standWordval;
                        }).catch(() => {

                        });
                    }
                });


            /**——————————————————————————————————标准词校验 结束*/
            /**——————————————————————————————————自动代入值 开始*/
            debugger
            //显示规则:0-名 1-值 2-名/值
            // if (propItemMap.keys("master_" + propid).length !== undefined) {
            // debugger
            var item = propItemMap.get("master_" + propid);
            if (!item) {
                return true;
            }
            for (var i in item) {
                debugger
                if (item[i].relationValid.rule_code == "002") {//002代表自动代入
                    let symbol = item[i].calculateSymbol;
                    if ((null == item[i].calculateSymbol || '' == item[i].calculateSymbol) && (null == item[i].slavecalculateSymbol || '' == item[i].slavecalculateSymbol)){
                        /**
                         * //当A选择人员后，B自动带出A选人员所在部门
                         * 注意：
                         * 1.配置的方式是将从属性的取值配置为 视图别名和属性别名，例如 ： caigouguizeshitu_chengben
                         * 2.主属性和从属性的质检符号都配置为空
                         */
                        debugger
                        if (optionMap != "" && optionMap != null && optionMap != undefined){
                            var salveStyle = item[i].salveProp.style;
                            var according = item[i].salveProp.according;
                            if(optionMap.has('datajson')){
                                var datajson = optionMap.get('datajson');
                                var slaveprop_value = item[i].slaveprop_value;
                                if (slaveprop_value != null && slaveprop_value != "") {
                                    var valiasname = slaveprop_value.split("_")[0];
                                    var paliasname = slaveprop_value.split("_")[1];
                                    if (salveStyle == '4' || salveStyle == '5') {
                                        row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
                                        row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = datajson[valiasname][paliasname + '|X'];
                                    } else {
                                        if (according == 0) {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname + '|X'];
                                        } else if (according == 1) {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
                                        } else {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname + '|X'] + "/" + datajson[valiasname][paliasname];
                                        }
                                    }
                                }
                            }else{
                                if(primaryData != null){
                                    that.$ajax
                                        .post('/infoTaskbill/queryJsonByPrimaryData', primaryData)
                                        .then((res) => {
                                            if (res.data.code == 200) {
                                                var datajson = res.data.obj;
                                                var slaveprop_value = item[i].slaveprop_value;
                                                if (slaveprop_value != null && slaveprop_value != "") {
                                                    var valiasname = slaveprop_value.split("_")[0];
                                                    var paliasname = slaveprop_value.split("_")[1];
                                                    if (salveStyle == '4' || salveStyle == '5') {
                                                        row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
                                                        row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = datajson[valiasname][paliasname + '|X'];
                                                    } else {
                                                        if (according == 0) {
                                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname + '|X'];
                                                        } else if (according == 1) {
                                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname];
                                                        } else {
                                                            row[item[i].salveView.byname][item[i].salveProp.byname] = datajson[valiasname][paliasname + '|X'] + "/" + datajson[valiasname][paliasname];
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                }
                            }
                        }
                    } else {
                        //let symbol = item[i].calculateSymbol;
                        // 判断视图类型
                        // 多值视图
                        // debugger

                        if (otherParameter.viewtype === "3") {
                            var mstval = row[item[i].masterView.byname][otherParameter.idx][item[i].masterProp.byname];
                            var confmval = item[i].masterprop_value;
                            var confsval = item[i].slaveprop_value;
                            if (mstval != '' && confmval != '' && confmval != null) {
                                if (checkout(mstval,confmval,symbol)) {
                                    if (confsval != '') {
                                        if (confsval.indexOf('~') && (item[i].salveProp.style == 5 || item[i].salveProp.style == 4) ) {
                                            row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = confsval.split('~')[0];
                                            row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // var according = item[i].salveProp.according;
                                            // if (according == 0) {
                                            //     row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // } else if (according == 1) {
                                            //     row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
                                            // } else {
                                            //     row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
                                            // }
                                        } else {
                                            row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = confsval;
                                        }
                                    }
                                }
                            } else {
                                // debugger
                                if (ifSelect) {//如果是下拉框和弹出框
                                    var according = item[i].salveProp.according;
                                    var salveStyle = item[i].salveProp.style;
                                    if(salveStyle == '4' || salveStyle == '5'){
                                        row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
                                        row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                    }else{
                                        if (according == 0) {
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                            } else {
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = optionMap.get(selectValue);
                                            }
                                        } else if (according == 1) {
                                            row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = selectValue;
                                            }
                                        } else {
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
                                            } else {
                                                row[item[i].salveView.byname][otherParameter.idx][item[i].salveProp.byname] = selectValue;
                                            }
                                        }
                                    }
                                } else {
                                    row[item[i].salveView.byname][item[i].salveProp.byname] = mstval;
                                }
                            }
                        }else if (otherParameter.viewtype === "4") {  // 多维视图数据带入
                            debugger
                            var mstval;
                            let isViewRow = false;
                            if (otherParameter.inputType === 'text'){
                                mstval = row[item[i].masterProp.byname];
                                isViewRow = true;
                            } else {
                                mstval = row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].masterProp.byname];
                            }
                            var confmval = item[i].masterprop_value;
                            var confsval = item[i].slaveprop_value;
                            let isTrue = true;
                            if (item[i].materialgeneral == '1' || item[i].orgs != ''){
                                isTrue = false;
                                const org = otherParameter.org;
                                if (item[i].orgs.indexOf(org) > -1){
                                    let orgArr = item[i].orgs.split(",");
                                    orgArr.forEach((item) => {
                                        if (item == org){
                                            isTrue = true;
                                        }
                                    })
                                }
                            }
                            if (mstval != '' && confmval != '' && confmval != null && isTrue) {
                                if (checkout(mstval,confmval,symbol)) {
                                    if (confsval != '') {
                                        if (confsval.indexOf('~') && (item[i].salveProp.style == 5 || item[i].salveProp.style == 4)) {
                                            row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = confsval.split('~')[0];
                                            row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // var according = item[i].salveProp.according;
                                            // if (according == 0) {
                                            //     row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // } else if (according == 1) {
                                            //     row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
                                            // } else {
                                            //     row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
                                            // }
                                        } else {
                                            row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = confsval;
                                        }
                                    }
                                }
                            } else if (isTrue) {
                                // debugger
                                if (ifSelect) {//如果是下拉框和弹出框
                                    var according = item[i].salveProp.according;
                                    var salveStyle = item[i].salveProp.style;
                                    if(salveStyle == '5' || salveStyle == '4'){
                                        row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
                                        row[otherParameter.parViewByname][otherParameter.org + "_" + item[i].masterView.name][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                    }else{
                                        if (according == 0) {
                                            if (salveStyle == '8') {
                                                row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
                                                row[otherParameter.parViewByname][otherParameter.org + "_" + item[i].masterView.name][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                            } else {
                                                row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = optionMap.get(selectValue);
                                            }
                                        } else if (according == 1) {
                                            row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
                                            if ( salveStyle == '8') {
                                                row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname + '|X'] = selectValue;
                                            }
                                        } else {
                                            if (salveStyle == '8') {
                                                row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue;
                                                row[otherParameter.parViewByname][otherParameter.org + "_" + item[i].masterView.name][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
                                            } else {
                                                row[otherParameter.parViewByname][otherParameter.org +"_"+ item[i].masterView.name][item[i].salveProp.byname] = selectValue + '/' + optionMap.get(selectValue);
                                            }
                                        }
                                    }
                                } else {
                                    row[item[i].salveProp.byname] = mstval;
                                }
                            }
                        } else {  // 其他类型视图 规则视图、业务视图
                            var mstval = row[item[i].masterView.byname][item[i].masterProp.byname];
                            var confmval = item[i].masterprop_value;
                            var confsval = item[i].slaveprop_value;
                            if (mstval != '' && confmval != '' && confmval != null) {
                                if (checkout(mstval,confmval,symbol)) {
                                    if (confsval != '') {
                                        if (confsval.indexOf('~') && (item[i].salveProp.style == 5  || item[i].salveProp.style == 4)) {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = confsval.split('~')[0];
                                            row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // var according = item[i].salveProp.according;
                                            // if (according == 0) {
                                            //     row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[1];
                                            // } else if (according == 1) {
                                            //     row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[0];
                                            // } else {
                                            //     row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = confsval.split('~')[0] + '/' + confsval.split('~')[1];
                                            // }
                                        } else {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = confsval;
                                        }
                                    }
                                }
                            } else {
                                // debugger
                                if (ifSelect) {//如果是下拉框和弹出框
                                    var according = item[i].salveProp.according;
                                    var salveStyle = item[i].salveProp.style;
                                    if(salveStyle == '5' || salveStyle == '4'){
                                        row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
                                        row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                    }else{
                                        if (according == 0) {
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
                                                row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = optionMap.get(selectValue);
                                            } else {
                                                row[item[i].salveView.byname][item[i].salveProp.byname] = optionMap.get(selectValue);
                                            }
                                        } else if (according == 1) {
                                            row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = selectValue;
                                            }
                                        } else {
                                            if (salveStyle == '8') {
                                                row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue;
                                                row[item[i].salveView.byname][item[i].salveProp.byname + '|X'] = selectValue + '/' + optionMap.get(selectValue);
                                            } else {
                                                row[item[i].salveView.byname][item[i].salveProp.byname] = selectValue + '/' + optionMap.get(selectValue);
                                            }
                                        }
                                    }
                                } else {
                                    row[item[i].salveView.byname][item[i].salveProp.byname] = mstval;
                                }
                            }
                        }

                    }
                }
                else if(item[i].relationValid.rule_code == "003"){//自动计算值，目前只支持规则视图和业务视图
                    debugger
                    if ("excutescript" != item[i].calculateSymbol.calcu_symbol){
                        continue;
                    }
                    /**
                     * 这里的主属性的实际的值，作为算法脚本的参数传入，然后执行算法得到结果就是从属性的值
                     */
                    debugger
                    var mstval = row[item[i].masterView.byname][item[i].masterProp.byname];
                    if(mstval == '' || mstval == null){
                        row[item[i].salveView.byname][item[i].salveProp.byname] = '';
                    }
                    var algid = item[i].masterprop_value;//主属性取值这里是算法脚本的id
                    //这里需要调用一下后台执行引擎获取结果
                    debugger
                    var sViewByname = item[i].salveView.byname;
                    var sPropByname = item[i].salveProp.byname;
                    queryValByAlg(mstval,algid,sViewByname,sPropByname,row,that);
                }
            }








            /**——————————————————————————————————组合校验 开始*/
            //CombinedDataMap 临时存储组合校验的值
            //num 表示是哪一行的数据
            debugger
            var item = propItemMap.get("master_" + propid);
            var returnState = true
            for (var k in item) {
                if (item[k].relationValid.rule_code == "011") {//011 组合验证
                    //todo 先找出要拼接的属性字段，进行重新拼接
                    var slaveviewId = item[k].slaveview_id;
                    var slavepropId = item[k].slaveprog_id;
                    var Combined = propItemMap.get("slave_" + slaveviewId + "|" + slavepropId);
                    //判断组装条件是否存在
                    //if (salveValue != null && salveValue != '' && salveValue.indexOf('_')) {
                    //说明是需要组装条件来判断的
                    //用来存储需要拼接的每个字段的值
                    var svArr = [];
                    for (var kk in Combined) {
                        let mstval = '';
                        if (Combined[kk].relationValid.rule_code == "011") {
                            //获取组装条件
                            let salveValue1 = Combined[kk].slaveprop_value;
                            if (salveValue1 != null && salveValue1 != '' && salveValue1.indexOf('_')) {
                                //todo 如果有组装条件则进行判断
                                let salveArray1 = salveValue1.split('_');
                                //说明有需要某个字段来判断的组合验证
                                let propView1 = salveArray1[0];
                                let propid1 = salveArray1[1];
                                let jiaoyanvalue1 = salveArray1[2].split(',');
                                //todo 获取这个组装条件在当前数据中的值
                                let chakValue1 = row[propView1][propid1];
                                if (jiaoyanvalue1.indexOf(chakValue1) == -1) {
                                    //todo 如果不满足组装条件跳过
                                    continue;
                                }
                            }
                            //todo 开始组装
                            // 主属性的表达式--拼接符
                            // debugger
                            var concatStr = '';
                            if (Combined[kk].calculateSymbol != null && Combined[kk].calculateSymbol != "" && Combined[kk].calculateSymbol != undefined) {
                                concatStr = Combined[kk].calculateSymbol.calcu_symbol;
                            }
                            //组装的值的位置
                            var pix = Combined[kk].masterprop_value;
                            //默认值
                            var intPix = 1;
                            //不为空时重新赋值
                            if (pix != null) {
                                intPix = parseInt(pix);
                            }
                            if (concatStr == null || concatStr == "") {
                                if (intPix != 1) {
                                    //如果为空默认使用|
                                    concatStr = '\\';
                                }
                            }
                            //获取需要组装的值，根据属性的类型来判断
                            // let mstval = '';
                            debugger;
                            if (Combined[kk].masterProp.style == '4' || Combined[kk].masterProp.style == '5') {
                                // mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname + '|X'];
                                if (Combined[kk].salveProp.according == '0'){
                                    mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname + '|X'];
                                } else if (Combined[kk].salveProp.according == '1') {
                                    mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname];
                                } else if (Combined[kk].salveProp.according == '2') {
                                    mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname] + '/' + row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname + '|X'];
                                } else {
                                    mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname];
                                }
                            } else {
                                mstval = row[Combined[kk].masterView.byname][Combined[kk].masterProp.byname];
                            }
                            if (mstval == null || mstval == "" || mstval == undefined) {
                                mstval = '';
                            }
                            svArr[intPix - 1] = mstval + "*_*" + concatStr;
                        }
                    }

                    if (svArr.length > 0) {
                        var salveVNew = '';
                        for (var i = 0; i < svArr.length; i++) {
                            if (svArr[i] != '' && svArr[i] != null) {
                                salveVNew += svArr[i].split("*_*")[1] + svArr[i].split("*_*")[0];
                            }
                        }
                        /*if (salveVNew.startsWith(concatStr)){
                            salveVNew = salveVNew.substring(0,salveVNew.length - 1);
                        }*/
                        //组装值的赋值
                        row[item[k].salveView.byname][item[k].salveProp.byname] = salveVNew;
                    }
                    /**----------------改版前的组合验证逻辑---------开始-----**/
//
                    /**
                     * 1.主属性的表达式：填主属性拼接符号
                     * 2.主属性取值：填主属性的序号
                     * @type {string|*}
                     */

                    //主属性取值
                    // 主属性的表达式
                    // debugger
                    // var concatStr = '';
                    // if (item[k].calculateSymbol != null && item[k].calculateSymbol != "" && item[k].calculateSymbol != undefined) {
                    //     concatStr = item[k].calculateSymbol.calcu_symbol;
                    // }
                    // //组装的值
                    // var slaveV = row[item[k].salveView.byname][item[k].salveProp.byname];
                    // //组装的值的位置
                    // var pix = item[k].masterprop_value;
                    // //默认值
                    // var intPix = 1;
                    // //不为空时重新赋值
                    // if (pix != null) {
                    //     intPix = parseInt(pix);
                    // }
                    // // debugger
                    // // if (this.GLOBAL.projectName === 'lvxue'|| this.GLOBAL.projectName === 'poc') {
                    // if (1==1) {
                    //     if (concatStr == null || concatStr == "") {
                    //         //金风poc 使用|
                    //         concatStr = "|";
                    //     }
                    //     //获取组装条件
                    //     var salveValue = item[k].slaveprop_value;
                    //     //判断组装条件是否存在
                    //     if (salveValue != null && salveValue != '' && salveValue.indexOf('_')) {
                    //         //分割组装条件，格式为视图别名_属性别名_校验值
                    //         var salveArray = salveValue.split('_');
                    //         //说明有需要某个字段来判断的组合验证
                    //         var propView = salveArray[0];
                    //         var propid = salveArray[1];
                    //         //获取这个组装条件的值
                    //         var chakValue = row[propView][propid];
                    //         //如果选择的属性与组合方式判断的条件一致的情况下
                    //         if (propid == item[k].masterProp.byname) {
                    //             //第一次选择了判断条件后面又修改的情况下，重新拼接所有的值
                    //             if (otherParameter.oldVal != null && otherParameter.oldVal != '' && otherParameter.oldVal != selectValue && selectValue != null && selectValue != '') {
                    //                 returnState = "changeValue"
                    //                 //先删除组装数据中的数据
                    //                 // debugger
                    //                 var svArrNew = [];
                    //                 if (slaveV != "" && slaveV != null) {
                    //                     for (var i = 0; i < intPix - 1; i++) {
                    //                         svArrNew[i] = slaveV.split(concatStr)[i];
                    //
                    //                     }
                    //                     slaveV = svArrNew.join(concatStr);
                    //                     row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
                    //                 }
                    //                 //获取需组装的值的所有属性
                    //                 var slaveProp = item[k].salveView.id + "|" + item[k].salveProp.id;
                    //                 var zuzhuang = propItemMap.get("slave_" + slaveProp);
                    //                 var svArrNew = [];
                    //                 for (var kk in zuzhuang) {
                    //                     if (zuzhuang[kk].relationValid.rule_code == "011") {
                    //                         //先获取组装条件
                    //                         var newSalveValue = zuzhuang[kk].slaveprop_value;
                    //                         //分割组装条件，格式为视图别名_属性别名_校验值
                    //                         var newSalveArray = newSalveValue.split('_');
                    //                         // if(newSalveArray[2].split(',').indexOf(selectValue) == -1){
                    //                         //     //如果校验不通过则不进行组装
                    //                         //     continue
                    //                         // }
                    //                         //默认值
                    //                         var newIntPix = 1;
                    //                         //获取组装的位置
                    //                         var newPix = zuzhuang[kk].masterprop_value;
                    //                         if (newPix != null) {
                    //                             newIntPix = parseInt(newPix);
                    //                         }
                    //                         if (newIntPix > intPix) {
                    //                             row[zuzhuang[kk].masterView.byname][zuzhuang[kk].masterProp.byname] = '';
                    //                             if (zuzhuang[kk].masterProp.style == 5) {
                    //                                 row[zuzhuang[kk].masterView.byname][zuzhuang[kk].masterProp.byname + '|X'] = '';
                    //                             }
                    //                         }
                    //                     }
                    //                 }
                    //             }
                    //             //如果是选择的属性也在组装中重新获取值
                    //             if (ifSelect) {
                    //                 chakValue = selectValue;
                    //             }
                    //         }
                    //         if (chakValue != null && chakValue != '') {
                    //             //获取判断的值
                    //             var jiaoyanvalue = salveArray[2].split(',');
                    //             if (jiaoyanvalue.indexOf(chakValue) == -1) {
                    //                 if (row.billname == '半成品') {
                    //                     if (chakValue != 1) {
                    //                         if (col.name != '附加信息') {
                    //                             slaveV = "";
                    //                             console.log(row[item[k].salveView.byname]);
                    //                             row[item[k].salveView.byname].fujiaxinxi9='';
                    //                             row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
                    //                         }
                    //                     }
                    //                 }
                    //                 //如果校验不通过则不进行组装
                    //                 continue
                    //             } else {
                    //                 if ((row.billname === '半成品' && col.name === '中类') && otherParameter.oldVal != propvalue) {
                    //                     /*slaveV = "";
                    //                     row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
                    //                     continue*/
                    //                     row[item[k].salveView.byname].fujiaxinxi9='';
                    //                     // debugger
                    //                     var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
                    //                     if (ifSelect) {
                    //                         mstval = optionMap.get(selectValue);
                    //                     }
                    //                     var svArr = [];
                    //                     svArr[intPix - 1] = mstval;
                    //                     if (intPix != 1) {
                    //                         for (var i = 0; i < intPix - 1; i++) {
                    //                             svArr[i] = '';
                    //                         }
                    //                     }
                    //                     slaveV = svArr.join(concatStr);
                    //                     row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
                    //                     continue;
                    //                 }
                    //             }
                    //         } else {
                    //             //当前的组合属性不是第一级，并且不是选择条件的属性时判断
                    //             if (pix != '1' && propid != item[k].masterProp.byname) {
                    //                 // debugger
                    //                 var propname = '';
                    //                 if (that.metaDatas) {
                    //                     that.metaDatas.forEach((item1) => {
                    //                         // debugger
                    //                         if (item1.vbyname == propView) {
                    //                             if (item1.jhBillPropertiesList) {
                    //                                 item1.jhBillPropertiesList.forEach((prop) => {
                    //                                     // debugger
                    //                                     if (prop.byname == propid) {
                    //                                         propname = prop.name;
                    //                                     }
                    //                                 });
                    //                             }
                    //                         }
                    //                     });
                    //                 }
                    //                 return "请先选择组合方式的判断条件:" + propname;
                    //             }
                    //         }
                    //     }
                    //     // debugger
                    //     //获取需要组装的值
                    //     var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
                    //     //雅化特殊处理
                    //     /*if (ifSelect) {
                    //         mstval = optionMap.get(selectValue);
                    //     }*/
                    //     //如果组装的值为空说明还未组装，是第一次组装
                    //     if (slaveV == "" || slaveV == null) {
                    //         var svArr = [];
                    //         svArr[intPix - 1] = mstval;
                    //         if (intPix != 1) {
                    //             for (var i = 0; i < intPix - 1; i++) {
                    //                 svArr[i] = '';
                    //             }
                    //         }
                    //         slaveV = svArr.join(concatStr);
                    //     } else {
                    //
                    //         /*if (slaveV.indexOf("--") < 0) {
                    //             var svArr = [slaveV];
                    //             svArr[intPix-1] = mstval;
                    //             if (intPix != 1) {
                    //                 for (var i=0;i<intPix-1;i++) {
                    //                     svArr[i] = '';
                    //                 }
                    //             }
                    //             slaveV = svArr.join('--');
                    //         }else{*/
                    //         // debugger
                    //         svArr = slaveV.split(concatStr);
                    //         svArr[intPix - 1] = mstval;
                    //         // }
                    //         slaveV = svArr.join(concatStr);
                    //     }
                    // } else {
                    //     // debugger
                    //     //获取需要组装的值
                    //     // debugger
                    //     var mstval = row[item[k].masterView.byname][item[k].masterProp.byname];
                    //     if (ifSelect) {
                    //         mstval = optionMap.get(selectValue);
                    //     }
                    //     //临时存储组合属性的key
                    //     var key = item[k].salveView.byname + "_" + item[k].salveProp.byname + "_" + num;
                    //     var CombinedData = [];
                    //     //如果组装的值为空说明还未组装，是第一次组装
                    //     if (slaveV == "" || slaveV == null) {
                    //         var svArr = [];
                    //         CombinedData[intPix - 1] = mstval + "*_*" + concatStr;
                    //         CombinedDataMap.set(key, CombinedData);
                    //         if (intPix != 1) {
                    //             slaveV = concatStr + mstval;
                    //         } else {
                    //             slaveV = mstval;
                    //         }
                    //     } else {
                    //         debugger
                    //         if (CombinedDataMap.size > 0 && CombinedDataMap != "" && CombinedDataMap != null && CombinedDataMap != undefined){
                    //             if (CombinedDataMap.has(key)) {
                    //                 CombinedData = CombinedDataMap.get(key);
                    //                 CombinedData[intPix - 1] = mstval + "*_*" + concatStr;
                    //                 var salveVNew = '';
                    //                 for (var i = 0; i < CombinedData.length; i++) {
                    //                     if (CombinedData[i] != '' && CombinedData[i] != null) {
                    //                         salveVNew += CombinedData[i].split("*_*")[1] + CombinedData[i].split("*_*")[0];
                    //                     }
                    //                 }
                    //                 slaveV = salveVNew;
                    //             } else {
                    //                 svArr = slaveV.split(concatStr);
                    //                 svArr[intPix - 1] = mstval;
                    //                 slaveV = svArr.join(concatStr);
                    //             }
                    //         }
                    //     }
                    // }
                    // //组装值的赋值
                    // row[item[k].salveView.byname][item[k].salveProp.byname] = slaveV;
                    /**----------------改版前的组合验证逻辑--------结束------**/

                }
            }
            return returnState
            /**——————————————————————————————————组合校验 结束*/

            /**——————————————————————————————————必填校验 开始*/
            if (slave2masterMap.size > 0) {
                var slaveid = slave2masterMap.get(propid);
                var sItem = propItemMap.get("master_" + propid);
                if (slaveid == undefined || slaveid == null) {
                    return true;
                }
                var masterprop_value = sItem.masterprop_value;
                var slaveprop_value = sItem.slaveprop_value;
                /**
                 * 先看一下主属性是否满足条件，如果主属性不满足条件就不校验了
                 * */
                var mval = row[sItem.masterView.byname][sItem.masterProp.byname];
                if (ifSelect) {
                    mval = selectValue;
                }
                var masterexpress =  sItem.calculateSymbol == null ? null : sItem.calculateSymbol.calcu_symbol;
                var masterFlag = that.validSinglePropByRule(sItem.masterprog_id, masterexpress, masterprop_value, mval);

                //必填做特殊处理
                var sval = row[sItem.salveView.byname][sItem.salveProp.byname];
                var slaveexpress =  sItem.slavecalculateSymbol == null ? null : sItem.slavecalculateSymbol.calcu_symbol;
                var slaveFlag = that.validSinglePropByRule(slaveid, slaveexpress, slaveprop_value, sval);
                if (masterFlag != 'true') {
                    parentRules[sItem.salveProp.byname] = [];
                    return true;
                } else {
                    if (slaveFlag != 'true') {
                        parentRules[sItem.salveProp.byname].push({
                            required: true,
                            message: '必填字段',
                            trigger: 'blur'
                        });
                        return slaveFlag;
                    } else {
                        parentRules[sItem.salveProp.byname] = [];
                        return true;
                    }
                }

            } else {
                return true
            }
            /**——————————————————————————————————必填校验 结束*/
            // }
        }

        async function queryValByAlg(mstval,algid,sViewByname,sPropByname,row,that){
            await that.$ajax
                .post('/infoAlg/excuteAlgByAlgid', {"mstval": mstval,"algid":algid})
                .then(function (response) {
                    if (response.data.code == 200) {
                        debugger
                        row[sViewByname][sPropByname] = response.data.msg;
                    }
                });
        }


        Vue.prototype.validSinglePropByRule = function (propid, express, value, realValue) {
            // if (typeof (value) == 'undefined' || typeof (realValue) == 'undefined' || value == '' || value == null || realValue == '') {
            //     debugger
            //     if("notnull" == express){
            //         return "未通过必填校验";
            //     }
            //     return '值为空,无法关联验证';
            // }
            var flag = 'true';
            try {
                switch (express) {
                    case "notnull":
                        if (realValue == null || realValue == "" || realValue == 'undefined') {
                            flag = "为必填项";
                        }
                        break;
                    case "isnull":
                        if (realValue != null && realValue != "" && realValue != 'undefined') {
                            flag = "为必空项";
                        }
                        break;
                    case '>':
                        if (!(parseInt(realValue) > parseInt(value))) {
                            flag = "必须大于" + value;
                        }
                        break;
                    case '<':
                        if (!(parseInt(realValue) < parseInt(value))) {
                            flag = "必须小于" + value;
                        }
                        break;
                    case '=':
                        if (!(parseInt(realValue) == parseInt(value))) {
                            flag = "必须等于" + value;
                        }
                        break;
                    case '!=':
                        if (!(parseInt(realValue) != parseInt(value))) {
                            flag = "必须不等于" + value;
                        }
                        break;
                    case '>=':
                        if (!(parseInt(realValue) >= parseInt(value))) {
                            flag = "必须大于等于" + value;
                        }
                        break;
                    case '<=':
                        if (!(parseInt(realValue) <= parseInt(value))) {
                            flag = "必须小于等于" + value;
                        }
                        break;
                    case 'inwithedge'://[3,10]
                        var tempVal = value.split(",");
                        var leftValue = tempVal[0].substring(1);
                        var rightValue = tempVal[1].substring(0, tempVal[1].length - 1);
                        if (!(parseInt(realValue) >= leftValue && parseInt(realValue) <= rightValue)) {
                            flag = "必须在" + value + "范围内";
                        }
                        break;
                    case 'inwithoutedge'://(3,10)
                        var tempVal1 = value.split(",");
                        var leftValue1 = tempVal1[0].substring(1);
                        var rightValue1 = tempVal1[1].substring(0, tempVal1[1].length - 1);
                        if (!(parseInt(realValue) > leftValue1 && parseInt(realValue) < rightValue1)) {
                            flag = "必须在" + value + "范围内";
                        }
                        break;
                    case 'any'://(1,5,10)
                        var tempVal2 = value.substring(1, value.length - 1).split(",");
                        for (var i in tempVal2) {
                            if (realValue == tempVal2[i]) {
                                flag = 'true';
                                break;
                            }
                        }
                        flag = "必须在" + value + "中选一个";
                        break;
                    case 'is'://字符串匹配
                        if (!(realValue == value)) {
                            flag = "必须是" + value;
                        }
                        break;
                    default:
                        return 'true';
                }
                return flag;
            } catch (e) {
                return 'true';
            }
        }
    }
}

function setValue(row,vByName,pByName,according,propStyle,value,optionMap,isMultiValueView,idx,hasMasterVal,datajson,key){
    debugger;
    if (row != undefined){
        var viewData = vByName != '' ? row[vByName] : row;
        if (isMultiValueView){
            viewData = row[vByName][idx];
        }
        if (value != '') {
            if (hasMasterVal) {
                if (value.indexOf('~') && (propStyle == 5 || propStyle == 4)) {
                    viewData[pByName] = value.split('~')[0];
                    viewData[pByName + '|X'] = value.split('~')[1];
                } else {
                    viewData[pByName] = value;
                    if (propStyle == 5 || propStyle == 4) {
                        viewData[pByName + '|X'] = value;
                    }
                }
            } else {
                if(propStyle == '4'||propStyle == '5'){
                    viewData[pByName] = value;
                    viewData[pByName + '|X'] = optionMap.get(value);
                }else{
                    if (according == 0) {
                        if (propStyle == '8') {
                            viewData[pByName] = value;
                            viewData[pByName + '|X'] = optionMap.get(value);
                        }else{
                            viewData[pByName] = optionMap.get(value);
                        }
                    } else if (according == 1) {
                        if (propStyle == '8') {
                            viewData[pByName] = value;
                            viewData[pByName + '|X'] = value;
                        }else{
                            viewData[pByName] = value;
                        }
                    } else {
                        if (propStyle == '8') {
                            viewData[pByName] = value;
                            viewData[pByName + '|X'] = value + '/' + optionMap.get(value);
                        }else{
                            viewData[pByName] = value + '/' + optionMap.get(value);
                        }
                    }
                }
            }
        } else if (datajson != null){
            if (propStyle == '4' || propStyle == '5') {
                viewData[pByName] = datajson[key];
                viewData[pByName + '|X'] = datajson[key + '|X'];
            } else {
                if (according == 0) {
                    viewData[pByName] = datajson[key + '|X'];
                } else if (according == 1) {
                    viewData[pByName] = datajson[key];
                } else {
                    viewData[pByName] = datajson[key + '|X'] + "/" + datajson[key];
                }
            }
        } else {
            if (propStyle == '4' || propStyle == '5') {
                viewData[pByName] = value;
                viewData[pByName + '|X'] = value;
            }
            viewData[pByName] = value;
        }
    }
}

function checkout(mstval, conmstval, symbolProp) {
    debugger
    const symbol = symbolProp != '' ? symbolProp.calcu_symbol : 'is';
    let split = conmstval.split(',');
    const isAllNumberValue = checkNumber(mstval, conmstval, split);
    switch (symbol) {
        case 'notnull':
            return mstval !== undefined && mstval != null && mstval !== '';
        case 'isnull':
            return mstval === null || mstval === undefined || mstval === '';
        case 'lengthgteq':
            return mstval.length >= conmstval;
        case 'lengthlteq':
            return mstval.length <= conmstval;
        case 'lengtheq':
            return mstval.length === conmstval;
        case 'lengthlt':
            return mstval.length < conmstval;
        case 'lengthgt':
            return mstval.length > conmstval;
        case '<':
            if (isAllNumberValue) {
                return mstval < conmstval;
            }
        case '=':
            if (isAllNumberValue) {
                return mstval === conmstval;
            }
        case '>':
            if (isAllNumberValue) {
                return mstval > conmstval;
            }
        case '!=':
            if (isAllNumberValue) {
                return mstval !== conmstval;
            }
        case '>=':
            if (isAllNumberValue) {
                return mstval >= conmstval;
            }
        case '<=':
            if (isAllNumberValue) {
                return mstval <= conmstval;
            }
        case 'is':
            return mstval === conmstval;
        case 'contain':
            return mstval.includes(conmstval);
        case 'inwithedge':
            split = conmstval.split[','];
            if (isAllNumberValue) {
                return mstval >= split[0] && mstval <= split[1];
            }
        case 'inwithoutedge':
            split = conmstval.split[','];
            if (isAllNumberValue) {
                return mstval > split[0] && mstval < split[1];
            }
        case 'iswithoutledge':
            split = conmstval.split[','];
            if (isAllNumberValue) {
                return mstval > split[0] && mstval <= split[1];
            }
        case 'iswithoutredge':
            split = conmstval.split[','];
            if (isAllNumberValue) {
                return mstval >= split[0] && mstval < split[1];
            }
    }
    return false;
}

function checkNumber(mstval, confMstval, scopeArr) {
    return !Number.isNaN(Number(mstval)) && scopeArr.length == 2
        ? (!Number.isNaN(Number(scopeArr[0])) && !Number.isNaN(Number(scopeArr[1])))
        : (!Number.isNaN(Number(confMstval)))
}
